<template>
  <div>
    <div class="tip">
      <span style="flex: 1">
        <i class="iconfont iconInfo-Solid"></i>
        {{ $t('system::rbac::auth_model_tip') }}
      </span>
      <div style="margin-left: 10px">
        <el-button @click="selectAll" style="margin-right: 10px">全选</el-button>
        <el-select
          style="width: 120px"
          @change="search"
          v-model="isChecked"
          :placeholder="$t('system::common::select_placeholder')"
        >
          <el-option v-for="item in checkedList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-input
          style="width: 200px; margin-left: 10px"
          :placeholder="$t('system::rbac::搜索模型名称')"
          v-model="keyword"
        >
          <el-button slot="append" icon="el-icon-search" type="primary" @click="search"></el-button>
        </el-input>
      </div>
    </div>
    <div class="content">
      <el-tree
        ref="modelTree"
        :data="dataList"
        show-checkbox
        node-key="fakerId"
        v-loading="loading"
        :props="{ children: 'columns' }"
        :expand-on-click-node="false"
        :check-on-click-node="true"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>{{ data.modelName || data.chinese }}</span>
          <!-- 已保存和已选择的维度才能设置 -->
          <el-button type="text" v-if="!data.measure && data.colId && node.checked" @click.stop="setValue(data, node)">
            {{ $t('system::rbac::设置') }}
          </el-button>
        </span>
      </el-tree>
    </div>
    <div style="display: flex; justify-content: space-between; margin-top: 10px">
      <el-pagination
        :page-size="page.pageSize"
        layout="total,prev, pager, next,jumper"
        :current-page.sync="page.pageNum"
        :total="page.total"
        @current-change="pageChange"
      ></el-pagination>
      <el-button :loading="sumbitLoading" @click="sumbit" type="primary" size="small" style="width: 90px">
        {{ $t('system::common::btn::save') }}
      </el-button>
    </div>

    <ValueAuth v-model="visible" :colId="colId" :roleId="roleId"></ValueAuth>
  </div>
</template>

<script>
import ValueAuth from './valueAuth.vue'
import { getModelList, getModelAuthList, saveModelAuthList } from '@/server/system'
export default {
  components: { ValueAuth },
  props: {
    roleId: {
      default: '',
      type: [Number, String],
    },
  },
  data() {
    return {
      dataList: [],
      visible: false,
      colId: '',
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      checkedList: [
        { label: this.$t('system::common::select_all'), value: '' },
        { label: this.$t('system::rbac::未授权'), value: 0 },
        { label: this.$t('system::rbac::已授权'), value: 1 },
      ],
      isChecked: '',
      keyword: '',
      loading: false,
      sumbitLoading: false,
    }
  },
  async mounted() {
    await this.pageChange()
  },
  methods: {
    async getModelList() {
      const data = await getModelList({
        ...this.page,
        keyword: this.keyword,
        roleId: this.roleId,
        isChecked: this.isChecked,
      })
      if (data.result.code === this.$code) {
        let res = data.result.data
        this.dataList = res.items.map(el => {
          let columns = [...el.dimensions, ...el.measures]
          // 插入fakerId用于树节点的勾选
          columns = columns.map(i => {
            return { ...i, fakerId: i.uuid + el.modelID }
          })
          return { ...el, fakerId: el.modelID, columns: columns }
        })
        this.page.total = res.totalCount
      }
    },
    async getModelAuthList() {
      const data = await getModelAuthList({ roleId: this.roleId })
      if (data.data.code === this.$code) {
        let selectedList = data.data.data
        let list = []
        selectedList.forEach(el => {
          this.dataList.forEach(item => {
            if (el.modelID === item.modelID) {
              el.columns.forEach(column => {
                item.columns.forEach((i, index) => {
                  if (column.uuid === i.uuid) {
                    // 插入已选择的模型维度和数值colId
                    this.$set(i, 'colId', column.colId)
                    list.push(i.fakerId)
                  }
                })
              })
            }
          })
        })
        this.$refs.modelTree.setCheckedKeys(list)
      }
    },
    selectAll() {
      let list = []
      this.dataList.forEach(item => {
        item.columns.forEach(column => {
          list.push(column.fakerId)
        })
      })
      this.$refs.modelTree.setCheckedKeys(list)
    },
    async search() {
      this.page.pageNum = 1
      this.pageChange()
    },
    async pageChange() {
      this.loading = true
      await this.getModelList()
      await this.getModelAuthList()
      this.loading = false
    },
    setValue(data, node) {
      this.colId = data.colId
      this.visible = true
    },
    async sumbit() {
      this.sumbitLoading = true
      let seletedList = this.$refs.modelTree.getCheckedNodes(false, true) // 已选择节点
      let leaf = this.$refs.modelTree.getCheckedNodes(true, true) // 已选择叶子节点
      let tree = []
      // 遍历已选的模型
      seletedList.forEach(el => {
        if (el.columns) {
          let i = { ...el }
          i.columns = []
          tree.push(i)
        }
      })
      // 将选择的维度和数值，重组为树状数据
      tree.forEach(el => {
        leaf.forEach(i => {
          if (el.modelID === i.modelID) {
            el.columns.push(i)
          }
        })
      })
      // 后端需要保存的数组
      const list = tree.map(el => {
        let measures = el.columns
          .filter(i => {
            return i.measure
          })
          .map(i => i.uuid)
        let dimensions = el.columns
          .filter(i => {
            return !i.measure
          })
          .map(i => i.uuid)
        return { modelID: el.modelID, measures: measures, dimensions: dimensions }
      })
      // 传给后端当前页的所有模型，用于后端保存
      const curret = this.dataList.map(el => {
        return el.modelID
      })
      const data = await saveModelAuthList({ authModels: list, roleId: this.roleId, currModelIDs: curret })
      if (data.result.code === this.$code) {
        this.pageChange()
        this.$message.success(this.$t('system::tip::save_success'))
      } else {
        this.$message.error(this.$t('system::tip::save_error'))
      }
      this.sumbitLoading = false
    },
  },
}
</script>

<style scoped lang="scss">
.tip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #999;
  font-size: 12px;
  .iconInfo-Solid {
    color: #999;
    font-size: 14px;
    margin-right: 4px;
  }
  margin: 16px 0;
  /deep/.el-input-group__append {
    padding: 0 12px;
    background: #0560fd !important;
    color: #fff !important;
    border: 1px solid #0560fd;
  }
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
/deep/.el-tree-node__content {
  padding-top: 24px !important;
  padding-bottom: 24px !important;
  padding-right: 24px !important;
  border: 1px solid #eeee;
  border-top: 0;
}
/deep/.el-tree-node__content + .el-tree-node__content {
  border-top: 1px solid #eee;
}
/deep/.el-tree {
  border-radius: 6px;
  border-top: 1px solid #eeee;
}
/deep/.el-tree-node__content > label.el-checkbox {
  margin-left: 24px;
  margin-right: 16px;
}
.pagination {
  position: absolute;
}
.content {
  overflow: auto;
  height: 441px;
}
</style>
